export default "__VITE_ASSET__B1QcOzt1__"